module.exports = __webpack_public_path__ + "img/loading.0813ab6f.png";